import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export type BadgeTone = "success" | "warning" | "danger" | "info" | "violet" | "default";

const TONES: Record<BadgeTone, string> = {
  success: "bg-success-dim text-success",
  warning: "bg-warning-dim text-warning",
  danger: "bg-danger-dim text-danger",
  info: "bg-info-dim text-info",
  violet: "bg-violet-dim text-violet",
  default: "bg-white/5 text-text2",
};

export function Badge({
  tone = "default",
  dot,
  children,
  className,
}: {
  tone?: BadgeTone;
  dot?: boolean;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-pill border border-transparent px-2 py-0.5 text-[10.5px] font-semibold whitespace-nowrap",
        TONES[tone],
        className,
      )}
    >
      {dot && <span className="h-[5px] w-[5px] rounded-full bg-current" />}
      {children}
    </span>
  );
}
